import type { AxiosResponse } from "axios";
import { createQuery } from "react-query-kit";

import { getApi } from "@api/apiPath";
import type { IApiResponse, IAxiosFn } from "@/api";
import { axiosClient } from "@/api";
import type { AxiosError } from "@api/types.ts";
import type {
  IReportDownloadEndpoint,
  IReportDownloadParams,
} from "@api/reports/types";
import type { ID } from "@constants";

const { key, getPath } = getApi("reports.medicalServiceServices.get");

type IResponse = AxiosResponse<IApiResponse<IReportDownloadEndpoint>>;
type IVariables = IReportDownloadParams;

export const getMedicalServiceServicesReport: IAxiosFn<
  IVariables,
  IResponse
> = async (params, signal) => {
  return axiosClient.get(getPath(params as unknown as { id: ID }), {
    params,
    signal,
  });
};

export const useGetMedicalServiceServicesReport = createQuery<
  IResponse,
  IVariables,
  AxiosError
>({
  primaryKey: key,
  queryFn: ({ queryKey: [_primaryKey, variables], signal }) =>
    getMedicalServiceServicesReport(variables, signal),
});
